import { PartyPopper, SearchX, VideoOff } from '@/lib/icons'
import { Button } from '@/components/ui/button'

interface NoResultsEmptyStateProps {
  searchTerm: string
  hasActiveFilters: boolean
  onClearFilters: () => void
}

/**
 * Qidiruv/filtr hech narsa bermagan holat (`docs/03-app-flow.md`, "Bo'sh holatlar":
 * "«{so'z}» bo'yicha topilmadi" + [Filtrni tozalash]). Umuman video yo'q bo'lsa (filtrsiz) —
 * neytral "Hali video yo'q" xabari.
 */
export function VideosNoResultsEmptyState({
  searchTerm,
  hasActiveFilters,
  onClearFilters,
}: NoResultsEmptyStateProps) {
  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center gap-3 px-6 text-center">
      <div className="rounded-full bg-app-card p-4">
        <SearchX size={28} className="text-app-hint" aria-hidden="true" />
      </div>
      <p className="max-w-xs text-sm text-app-text">
        {searchTerm.length > 0 ? (
          <>
            «<span className="font-medium">{searchTerm}</span>» bo'yicha topilmadi
          </>
        ) : (
          "Hali video yo'q"
        )}
      </p>
      {hasActiveFilters && (
        <Button variant="secondary" size="sm" onClick={onClearFilters}>
          Filtrni tozalash
        </Button>
      )}
    </div>
  )
}

/**
 * Kanban ustuni bo'sh holati — `docs/03`: "Bu bosqichda video yo'q" + kulrang ikonka.
 *
 * `celebratory` — `docs/03` "Bo'sh holatlar": "'Bugun tekshirish' bo'sh" → "🎉 Bugun
 * tekshiradigan video yo'q!". Tez filtr "Bugun"/"Kechikkan" faol bo'lganda va PM Tekshiruvda
 * ustuni bo'sh bo'lsa, bu quvonchli xabar oddiy "video yo'q" o'rniga ko'rsatiladi.
 */
export function VideoKanbanColumnEmptyState({ celebratory }: { celebratory?: boolean }) {
  if (celebratory) {
    return (
      <div className="flex flex-col items-center gap-2 rounded-card border border-dashed border-urgency-done/40 bg-urgency-done/5 px-3 py-6 text-center">
        <PartyPopper size={20} className="text-urgency-done-text" aria-hidden="true" />
        <p className="text-xs font-medium text-urgency-done-text">
          Bugun tekshiradigan video yo'q!
        </p>
      </div>
    )
  }

  return (
    <div className="flex flex-col items-center gap-2 rounded-card border border-dashed border-app-border px-3 py-6 text-center">
      <VideoOff size={20} className="text-app-hint" aria-hidden="true" />
      <p className="text-xs text-app-hint">Bu bosqichda video yo'q</p>
    </div>
  )
}
